module.exports = __webpack_public_path__ + "static/media/Banner-3.d5257b88.jpg";